module.exports = __webpack_public_path__ + "img/img-benefit-quac-1.2fdbe068.svg";